import { render, staticRenderFns } from "./preview_1.vue?vue&type=template&id=485e8659&scoped=true"
import script from "./preview_1.vue?vue&type=script&lang=js"
export * from "./preview_1.vue?vue&type=script&lang=js"
import style0 from "./preview_1.vue?vue&type=style&index=0&id=485e8659&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485e8659",
  null
  
)

export default component.exports